<script>
  import { Chart } from 'flowbite-svelte';
  import { formatNumberWithIntl } from './utils';
  import Heading from './Heading.svelte';
  import Truncate from './Truncate.svelte';
  import PercentChange from './PercentChange.svelte';
  import CopyButton from './CopyButton.svelte';
  import { _ } from 'svelte-i18n';

  export let currentDailyResults = [];
  export let previousDailyResults = [];
  export let topShortlinksData = [];
</script>

<ol class="flex flex-1 flex-col">
  {#each currentDailyResults as stats, index}
    <li class="flex flex-col gap-6 border-b py-6 xl:flex-row">
      <div class="flex gap-4 xl:flex-1">
        <Heading level={2}>
          {index + 1}.
        </Heading>
        <div>
          <a href="/links?shortlinkId={topShortlinksData[index].shortlink.id}">
            <Heading level={2} class="pb-2">
              <Truncate
                text={topShortlinksData[index].shortlink.name}
                length={20}
              />
            </Heading>
          </a>
          <Heading level={3} class="pb-2">
            {formatNumberWithIntl(stats.total_mobile_journeys)}
            <span class="text-base">
              {$_('_shared.chart.topShortlinks.mobileClicks', {
                default: 'Mobile Clicks',
              })}</span
            >
          </Heading>
          <div class="flex gap-4">
            <a
              target="_blank"
              href={topShortlinksData[index].shortlink.shortlink}
              >{topShortlinksData[index].shortlink.shortlink}</a
            >
            <CopyButton
              shortlink={topShortlinksData[index].shortlink.shortlink}
            />
          </div>
        </div>
      </div>
      <div class="flex-col xl:w-24 xl:flex-row">
        <Chart
          options={{
            chart: {
              sparkline: {
                enabled: true,
              },
              height: '40px',
              maxWidth: '100%',
              fontFamily: 'Inter, sans-serif',
            },
            stroke: {
              width: 2,
              curve: 'smooth',
            },
            series: [
              {
                name: 'Total Clicks',
                data: stats.daily_results.map(
                  (result) => result.mobile_journeys,
                ),
                color:
                  previousDailyResults[index]?.total_mobile_journeys >
                  stats.total_mobile_journeys
                    ? '#E02424'
                    : '#0E9F6E',
              },
            ],
            xaxis: {
              categories: stats.daily_results.map((result) => result.date),
              labels: {
                show: false,
                style: {
                  fontFamily: 'Inter, sans-serif',
                  cssClass: 'text-xs font-normal fill-gray-500',
                },
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            yaxis: {
              show: false,
            },
            grid: {
              padding: {
                top: 2,
                bottom: 2,
              },
            },
          }}
        />
        <div class="mt-2 text-right text-xs">
          <PercentChange
            previous={previousDailyResults[index]?.total_mobile_journeys}
            current={stats.total_mobile_journeys}
            >{$_('_shared.shortlinksChart.vsPreviousPeriod', {
              default: 'vs. previous period',
            })}
          </PercentChange>
        </div>
      </div>
    </li>
  {/each}
</ol>
